const PLENARY_SESSIONS = {
  'monday-plenary-session-1-ball': {
    name: 'Monday Joint Plenary #1',
    date: 'Monday, June 23',
    time: '8:00am-9:30am',
    presentations: ['mon1', 'mon2', 'mon3', 'mon4', 'mon5', 'mon6'],
    room: 'ball',
    id: 'monday-plenary-session-1-ball',
  },
  'monday-plenary-session-2-ball': {
    name: 'Monday Joint Plenary #2',
    date: 'Monday, June 23',
    time: '10:00am-12:00pm',
    done: false,
    presentations: ['mon7', 'mon8', 'mon9', 'mon10'],
    room: 'ball',
    id: 'monday-plenary-session-2-ball',
  },
  'tuesday-plenary-sessions-ballB': {
    name: 'Tuesday GEM Plenary Session',
    date: 'Tuesday, June 24',
    time: '8:00am-9:30am',
    done: false,
    presentations: ['tue1', 'tue2', 'tue3', 'tue4'],
    room: 'ballB',
    id: 'tuesday-plenary-sessions-ballB',
  },
  'tuesday-plenary-sessions-ballA': {
    name: 'Tuesday CEDAR Plenary Session',
    date: 'Tuesday, June 24',
    time: '8:00am-9:30am',
    done: false,
    presentations: [
      'tue5',
      'tue6',
      'tue7',
      'tue8',
      'tue9',
      'tue10',
      'tue11',
      'tue12',
    ],
    room: 'ballA',
    id: 'tuesday-plenary-sessions-ballA',
  },
  'wednesday-plenary-session-ball': {
    name: 'Wednesday Joint Plenary - Agency Updates',
    date: 'Wednesday, June 25',
    time: '8:00am-10:00am',
    done: false,
    presentations: ['wed1', 'wed3', 'wed4', 'wed5', 'wed6'],
    room: 'ball',
    id: 'wednesday-plenary-session-ball',
  },
  'thursday-plenary-sessions-ballB': {
    name: 'Thursday GEM Plenary Session',
    date: 'Thursday, June 26',
    time: '8:00am-9:30am',
    done: false,
    presentations: ['thu1', 'thu2', 'thu3', 'thu4'],
    room: 'ballB',
    id: 'thursday-plenary-sessions-ballB',
  },
  'thursday-plenary-sessions-ballA': {
    name: 'Thursday CEDAR Plenary Session',
    date: 'Thursday, June 26',
    time: '8:00am-9:30am',
    done: false,
    presentations: ['thu5', 'thu6', 'thu7', 'thu8'],
    room: 'ballA',
    id: 'thursday-plenary-sessions-ballA',
  },
  'thursday-plenary-session-2-ball': {
    name: 'Thursday Joint Plenary Session: Compassionate Leadership for Burnout',
    date: 'Thursday, June 26',
    time: '8:00am-9:30am',
    done: false,
    presentations: ['thuJoint'],
    room: 'ball',
    id: 'thursday-plenary-session-2-ball',
  },

  'friday-plenary-session-ball': {
    name: 'Friday Joint Plenary Session: Heliophysics Moving Forward',
    date: 'Friday, June 27',
    time: '8:00am-10:00am',
    done: false,
    presentations: ['fri1', 'fri2', 'fri3', 'fri4'],
    room: 'ball',
    id: 'friday-plenary-session-ball',
  },
}
const PLENARY_PRESENTATIONS = {
  mon1: {
    title: 'Opening Remarks',
    host: 'Christine Gabrielse and Mark Conde',
  },
  mon2: {
    title: 'Welcome from AGS Director',
    host: 'Anne Johansen and John Hannan',
  },
  mon3: {
    title: 'Code of Conduct Review',
    host: 'Mark Conde and Christine Gabrielse',
  },
  mon4: {
    title: 'Student Day Overview and Introductions',
    host: 'Sophie, Aidan, Austin, Erica',
  },
  mon5: {
    title: 'Anti-Harrassment Tutorial',
    host: 'Blair Schneider',
  },
  mon6: {
    title: 'Workshop Overview',
    host: 'Christine Gabrielse and Mark Conde',
  },
  mon7: {
    title: 'Distinguished Lecture',
    host: 'Phil Erickson',
  },
  mon8: {
    title: 'Decadal Survey Overview on Effective Outreach',
    host: 'Allison Jaynes',
  },
  mon9: {
    title: 'Public Outreach and Engagement: From Space Sounds to Penguins',
    host: 'Michael Hartinger',
  },
  mon10: {
    title: 'Kathryn McWilliams Memorium',
    host: 'Daniel Billett',
  },
  tue1: {
    title: 'Welcome and Announcements',
    host: 'Christine Gabrielse',
  },
  tue2: {
    title: 'Focus Group Tutorial: Radiation Belts as a System of Systems',
    host: 'Harriet George',
  },
  tue3: {
    title:
      "Focus Group Tutorial: Magnetic Reconnection: The Key to Understanding Earth's Space Environment",
    host: 'Yi Qi',
  },
  tue4: {
    title: 'Session Convener Annoucements',
    host: 'Session Conveners',
  },
  tue5: {
    title: 'Welcome from CPAESS Director',
    host: 'Hanne Mauriello',
    order: 8,
  },
  tue6: {
    title: 'Welcome from CSSC Chairs',
    host: 'Lynn Harvey, Mark Conde',
    order: 8,
  },
  tue7: {
    title: 'Grand Challenge report',
    subtitle:
      'Impact of Terrestrial Weather on the Space Weather of the Ionosphere-Thermosphere-Mesosphere',
    host: 'Jens Oberheide',
  },
  tue8: {
    title: 'Grand Challenge report',
    subtitle:
      'The role of gravity waves in the mesosphere, thermosphere and ionosphere cross-scale coupling and irregularities: Observations and numerical simulations',
    host: 'Titus Yuan',
  },
  tue9: {
    title: 'New Grand Challenge Introduction',
    subtitle:
      'Redefining Polar Cap Patches: Understanding High-Latitude Irregularities, and their implications for the coupled MIT system',
    host: 'Leslie Lamarche',
  },
  tue10: {
    title: 'Early Career Science Highlight I',
    subtitle:
      'Interactions between Geomagnetic Activity and Sudden Stratosphere Warmings',
    host: 'Komal Kumari',
  },
  tue11: {
    title: 'Science Highlight I: the EZIE mission',
    host: 'Bill Swartz',
  },
  tue12: {
    title: 'CEDAR Strategic Plan',
    subtitle: 'The Value of CEDAR Science',
    host: 'Lynn Harvey, Kristina Lynch, Katelyn Greer, Romina Nikoukar, Gareth Perry',
  },
  wed1: {
    title: 'NSF',
    host: 'Shikha Raizada (virtual) and Vania Jordanova (virtual)',
  },
  wed3: {
    title: 'NOAA',
    host: 'Irfan Azeem (virtual)',
  },
  wed4: {
    title: 'ONR',
    host: 'Bruce Fritz',
  },
  wed5: {
    title: 'AFOSR',
    host: 'Julie Moses (virtual)',
  },
  wed6: {
    title: 'Q and A',
    host: 'All Agencies',
  },

  thu1: {
    title: 'Welcome and Announcements',
    host: 'Allison Jaynes',
  },

  thu2: {
    title: 'Focus Group Tutorial',
    subtitle:
      "Solar-Wind/Magnetosphere Coupling: Multiscale Dayside Transients and their Effect on Earth's Magnetosphere",
    host: 'Savvas Raptis ',
  },
  thu3: {
    title: 'GEM Student - Chosen Speaker: Budget Science in an Uncertain Age',
    host: 'Tony Rogers',
  },
  thu4: {
    title: 'Session Convener Announcements',
    host: 'Session Conveners',
  },
  thu5: {
    title: 'Poster Prize Announcement',
    host: 'Titus Yuan',
  },

  thu6: {
    title: 'CEDAR Prize Lecture',
    subtitle:
      'Global-scale wave impacts on the coupled ionosphere-thermosphere system from daily to sub-seasonal timescales',
    host: 'Jens Oberheide',
  },
  thu7: {
    title: 'Early Career science highlight II',
    subtitle:
      'Wave-Wave Interactions and Modulation in the Mesosphere and Lower Thermosphere',
    host: 'Zishun Qiao',
  },
  thu8: {
    title: 'Science Highlight II',
    subtitle:
      'Is the lower atmosphere important for satellite drag and reentry?',
    host: 'Jia Yue',
  },
  thuJoint: {
    title: 'Compassionate Leadership for Burnout',
    host: 'Rebecca Pope-Ruark',
  },

  fri1: {
    title: 'Welcome and Announcements',
    host: 'Mark Conde and Christine Gabrielse',
  },

  fri2: {
    title: 'Decadal Survey Summary',
    host: 'Stephen Fuselier and Robyn Millan',
  },
  fri3: {
    title:
      'NASA LWS Program Analysis Group (LPAG) Updates and LWS Focused Science Topics (FST) Solicitation for FY26+',
    host: 'Shasha Zhou',
  },
  fri4: {
    title: 'Closing Remarks',
    host: 'Lynn Harvey, Allison Jaynes, Christine Gabrielse, Mark Conde',
  },
}

const PLENARY_LIST = [
  'monday-plenary-session-1-ball',
  'monday-plenary-session-2-ball',
  'tuesday-plenary-sessions-ballB',
  'tuesday-plenary-sessions-ballA',
  'wednesday-plenary-session-ball',
  'thursday-plenary-sessions-ballB',
  'thursday-plenary-sessions-ballA',
  'friday-plenary-session-ball',
]

export { PLENARY_LIST, PLENARY_SESSIONS, PLENARY_PRESENTATIONS }
